import React from 'react';
import { Box } from '@mui/material';
import { Outlet } from 'react-router';
import { Drawer } from '@/core/features/drawer';
import { Modal } from '@/core/features/modal';
import { Snackbar } from '@/core/features/snackbar';
import { Loader } from '@/core/features/loader';
import AuthHeader from '@/components/AuthHeader';
import Sidebar from '@/components/Sidebar/Sidebar';
import { useSidebarItems } from '@/utils/hooks/useSidebarItems';
import styles from './styles';

const RootLayout = () => {
  const items = useSidebarItems();
  return (
    <>
      <Drawer />
      <Modal />
      <Snackbar />
      <Loader />
      <AuthHeader />

      <Box sx={styles.root}>
        {items && <Sidebar items={items} />}

        <Box sx={styles.main} component="main">
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default RootLayout;
